export default __webpack_public_path__ + "static/afi-logo-v3-d143b0d74b5a0a024e50f13b0b13bb7a.svg";